module.exports = __webpack_public_path__ + "static/media/doctor4-300.86bd303f.webp";